import React, { useState, useEffect } from 'react';

import Table from './Table';
import personalData from '../../data/stats';

const PersonalStats = () => {
  const [data, setData] = useState(personalData);

  useEffect(() => {
    const timer = setInterval(() => {
      const divisor = 1000 * 60 * 60 * 24 * 365.2421897;
      const birthTime = new Date('1992-01-03T14:30:00');
      setData((prevData) => ({
        ...prevData,
        age: {
          label: 'Current age',
          value: ((Date.now() - birthTime) / divisor).toFixed(11),
        },
      }));
    }, 25);
    return () => { clearInterval(timer); };
  }, []);

  return (
    <>
      <h3>Some stats about me</h3>
      <Table data={Object.keys(data).map((key) => data[key])} />
    </>
  );
};

export default PersonalStats;
